import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { PenTool, Truck, Palette, Sparkles } from 'lucide-react';
export function PersonalizationSection() {
  const steps = [{
    icon: <Palette className="w-6 h-6" data-id="element-935" />,
    title: 'Select Your Colors',
    description: 'Choose from our premium range of metallic, pastel, and chrome balloon colors to match your theme.'
  }, {
    icon: <PenTool className="w-6 h-6" data-id="element-936" />,
    title: 'Add Your Message',
    description: 'Personalize with names, ages, or special messages in beautiful custom typography.'
  }, {
    icon: <Sparkles className="w-6 h-6" data-id="element-937" />,
    title: 'Add Special Details',
    description: 'Customize with feathers, confetti, ribbons, and decorative bases for that extra wow factor.'
  }, {
    icon: <Truck className="w-6 h-6" data-id="element-938" />,
    title: 'Delivered Ready',
    description: 'Your custom arrangement arrives fully inflated and beautifully presented, ready to celebrate.'
  }];
  return <section className="py-24 bg-rose-50/50" data-id="element-939">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-940">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-941">
          {/* Left Side: Image Grid */}
          <div className="relative" data-id="element-942">
            <div className="grid grid-cols-2 gap-4" data-id="element-943">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6
            }} className="space-y-4 mt-12" data-id="element-944">
                <img src="https://cdn.magicpatterns.com/uploads/4WoFcxWgJXeKoP4GQRMRQ3/71f1e28d1b366ac4f58abe86dfcc85e7.jpg" alt="Blue and silver personalized balloon arrangement" className="rounded-2xl shadow-lg w-full h-64 object-cover" data-id="element-945" />
                <img src="https://cdn.magicpatterns.com/uploads/uH4eA9BSC8SkUpjsQDPegz/584babe5f4339cda959d4ccfeadc5321.jpg" alt="Elegant 80th birthday gold and silver balloon tower" className="rounded-2xl shadow-lg w-full h-48 object-cover" data-id="element-946" />
              </motion.div>
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="space-y-4" data-id="element-947">
                <img src="https://cdn.magicpatterns.com/uploads/kXYTyNHLhjWtPqWzQrhpar/6983ba56ba37806d86ed37bafe6c2131.jpg" alt="Happy 22nd Dharma personalized bubble balloon" className="rounded-2xl shadow-lg w-full h-48 object-cover" data-id="element-948" />
                <img src="https://cdn.magicpatterns.com/uploads/hhC3wkvD9WP2JyyETJL7wU/9ac1a1faa5e8b3baf9b7d1455c01881c.jpg" alt="Happiest 18th Ella purple themed balloon" className="rounded-2xl shadow-lg w-full h-64 object-cover" data-id="element-949" />
              </motion.div>
            </div>

            {/* Decorative circle */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-white/50 rounded-full blur-3xl -z-10" data-id="element-950" />
          </div>

          {/* Right Side: Content */}
          <div data-id="element-951">
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-952">
              <div className="inline-flex items-center px-4 py-2 rounded-full bg-rose-100 text-rose-700 font-medium text-sm mb-6" data-id="element-953">
                <Sparkles className="w-4 h-4 mr-2" data-id="element-954" />
                Starting from R200
              </div>

              <h2 className="font-serif text-4xl font-bold text-gray-900 mb-6" data-id="element-955">
                Personalized Balloon Art
              </h2>
              <p className="text-lg text-gray-600 mb-12 leading-relaxed" data-id="element-956">
                Make any occasion unforgettable with our custom balloon
                arrangements. Whether it's a milestone birthday, a welcome home
                gift, or a romantic gesture, we craft personalized designs that
                speak from the heart.
              </p>

              <div className="space-y-8" data-id="element-957">
                {steps.map((step, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: 20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.5,
                delay: index * 0.1
              }} className="flex items-start" data-id="element-958">
                    <div className="flex-shrink-0 w-12 h-12 rounded-full bg-white shadow-sm flex items-center justify-center text-rose-500 mr-4 border border-rose-100" data-id="element-959">
                      {step.icon}
                    </div>
                    <div data-id="element-960">
                      <h3 className="font-bold text-gray-900 mb-1" data-id="element-961">
                        {step.title}
                      </h3>
                      <p className="text-gray-600 text-sm" data-id="element-962">
                        {step.description}
                      </p>
                    </div>
                  </motion.div>)}
              </div>

              <div className="mt-12" data-id="element-963">
                <Button size="lg" data-id="element-964">Start Customizing</Button>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}